import { Provider, APP_BOOTSTRAP_LISTENER, ComponentRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FilterService } from '@beecore/core';
import { SFE_CONSTANTS_TOKEN } from '../tokens/sfe-constants.token';
import { filter, skip, distinctUntilChanged } from 'rxjs/operators';

export function sfeBootstrap() {
  return async (componentRef: ComponentRef<any>) => {
    // tslint:disable-next-line: one-variable-per-declaration
    const route = componentRef.injector.get(ActivatedRoute),
      router = componentRef.injector.get(Router),
      filterService = componentRef.injector.get(FilterService),
      constants = componentRef.injector.get(SFE_CONSTANTS_TOKEN);

    filterService
      .asObservable<number>(constants.companyFilter)
      .pipe(
        distinctUntilChanged(),
        filter(x => !!x),
        skip(1),
      )
      .subscribe(() => {
        if (!router.isActive('/centralnotificacoes', false) &&
          !router.isActive('/centralnotificacoes/configurar-excecao', false) &&
          !router.isActive('/auditorias/empresa', false) &&
          !router.isActive('/auditorias/estabelecimentos', false) &&
          !router.isActive('/auditorias/detalhes', false) &&
          !router.isActive('/consultasefaz/resumo', false) &&
          !router.isActive('/consultasefaz/detalhe', false) &&
          !router.isActive('/consultasefaz/log', false)) {
          router.navigate(['/'], { relativeTo: route });
        }
      });
  };
}

export const SFE_BOOTSTRAP_PROVIDER: Provider = {
  provide: APP_BOOTSTRAP_LISTENER,
  useFactory: sfeBootstrap,
  multi: true
};
